// Always use plural values
// API_KEYS: api_keys <--- CORRECT
// API_KEYS: api_key <--- INCORRECT

export enum DB_COLLECTION_NAMES {
  // A
  ARTICLES = 'articles',
  ARTICLE_CATEGORIES = 'article_categories',
  ARTICLE_SUB_CATEGORIES = 'article_sub_categories',
  ARTICLE_TAGS = 'article_tags',
  ACCESS_CREDENTIALS = 'access_credentials',
  API_KEYS = 'api_keys',
  AUTH_REQUESTS = 'auth_requests',
  AUTH_CODES = 'auth_codes',
  // C
  CONNECTED_APPS = 'connected_apps',
  CONNECTIONS = 'connections',
  COUNTERS = 'counters',
  TEMPORARY_CUSTOMER_BULK = 'temporary_customer_bulk',
  // D
  DELETED_CLIENT_SECRETS = 'deleted_client_secrets',
  DELETED_API_KEYS = 'deleted_api_keys',
  DOCUMENT_TEMPLATES = 'document_templates',
  DOCUMENTS = 'documents',
  // E
  ERROR_LOGS = 'error_logs',
  MAILBOX_CONFIG = 'mailbox_config',
  // G
  GATEWAYS = 'gateways',
  // I
  IDENTITIES = 'identities',
  INTEGRATION_ENDPOINTS = 'integration_endpoints',
  INTEGRATION_MAPPINGS = 'integration_mappings',
  TEMPORARY_INVOICE_BULK = 'temporary_invoice_bulk',
  // L
  LOGS = 'logs',

  // M
  MESSAGES = 'messages',
  MESSAGES_RESPONSES = 'messages_responses',
  MODULES = 'modules',
  // N
  NOTIFICATIONS = 'notifications',
  NOTIFICATION_IDENTITIES = 'notification_identities',
  NOTICES = 'notices',
  // O
  OTP = 'otps',
  // P
  PERMISSIONS = 'permissions',
  PRIVILEGES = 'privileges',
  POST_IT_NOTES = 'post-it-notes',
  PERSONALIZATIONS = 'personalizations',
  PREDEFINED_REFERENCES_COUNTRIES = 'predefined_reference_countries',
  PREDEFINED_REFERENCES_STATES = 'predefined_reference_states',
  PREDEFINED_REFERENCES_DISTRICTS = 'predefined_reference_districts',
  PREDEFINED_REFERENCES_CITIES = 'predefined_reference_cities',
  PUSH_NOTIFICATION_DEVICE = 'push_notification_devices',

  // Q
  QUICK_ACTIONS = 'quick_actions',
  // R
  REFERENCE_CATEGORIES = 'reference_categories',
  REFERENCES = 'references',
  REFRESH_TOKENS = 'refresh_tokens',
  ROLES = 'roles',
  REMINDER = 'reminders',
  RECEIPTS = 'receipts',
  RECONCILIATION = 'reconciliation',
  REPORTS = 'reports',
  RECEIPTS_ID = 'receipts_id',
  RECEIPTS_BULK_ID = 'receipts_bulk_id',

  // S

  /*Saas*/
  SAAS_TENANT = 'saas_tenants',
  SAAS_TENANT_ID = 'saas_tenants_tracker',
  SAAS_SUBSCRIPTIONS = 'saas_subscriptions',
  SAAS_INVOICES = 'saas_invoices',
  SAAS_PAYMENTS = 'saas_payments',

  /*Setup*/
  SETUP_BACKUP_SCHEDULES = 'setup_backup_schedules',
  SETUP_CLIENT = 'setup_clients',
  SETUP_COLOR_PALLETS = 'setup_color_palettes',
  SETUP_GENERAL = 'setup_generals',
  SETUP_IAM = 'setup_iams',
  SETUP_LANGUAGES = 'setup_languages',
  SETUP_CURRENCIES = 'setup_currencies',
  SETUP_MESSAGE_GROUPS = 'setup_message_groups',
  SETUP_MESSAGE_RULES = 'setup_message_rules',
  SETUP_MESSAGE_CONFIG = 'setup_message_config',
  SETUP_NOTIFICATION_CONFIG = 'setup_notification_configs',
  SETUP_MAILBOX_CONFIG = 'setup_mailbox_config',
  SETUP_PWA = 'setup_progressive_web_apps',
  SETUP_REFERENCE_MAPPINGS = 'setup_reference_mappings',
  SETUP_RELEASES = 'setup_releases',
  SETUP_EXTERNAL_SYSTEMS = 'setup_external_systems',
  SETUP_SECURITY = 'setup_securities',
  SETUP_SECURITY_WEB_HOOKS = 'setup_security_web_hooks',
  SETUP_STORAGE = 'setup_storages',
  SETUP_SUPPORT = 'setup_supports',
  SETUP_SYSTEM_VARIABLES = 'setup_system_variables',
  SETUP_MESSAGE = 'setup_messages',
  SETUP_SAAS = 'setup_saas',
  SETUP_PAYMENT = 'setup_payments',

  STORAGE = 'storages',
  STORAGE_ACCESS_TOKENS = 'storage_access_tokens',
  STORAGE_ENTITY = 'storage_entities',
  STORAGE_ENTITY_INTERNAL_SHARE = 'storage_entities_internal_shares',
  STORAGE_ENTITY_EXTERNAL_SHARE = 'storage_entities_external_shares',

  // T
  TEMPLATES = 'templates',
  TASK = 'tasks',
  TRANSACTIONS = 'transactions',

  // U
  USERS = 'users',
  // V
  VERIFICATION_TOKENS = 'verification_tokens',
  VIRTUAL_MODULE_DATA = 'virtual_module_data',

  // W
  WIDGETS = 'widgets',
  WORKFLOWS = 'workflows',
  WORKFLOW_INSTANCES = 'workflow_instances',
  WORKFLOW_PHASES = 'workflow_phases',
  WORKFLOW_CONNECTIONS = 'workflow_connections',
  WIDGET_LAYOUT = 'widget_layouts',
  SETUP_EXTERNAL_STORAGE_LOCATION_CONFIG = 'SETUP_EXTERNAL_STORAGE_LOCATION_CONFIG',

  // Please add bms entries below
  /********** BMS SYSTEM **********/
  //A
  TEMP_POLICY = 'temp_policy',
  // D
  DEBIT_NOTES = 'debit_notes',
  DEBIT_NOTES_ID = 'debit_notes_id',

  // C
  CUSTOMER_USERS = 'customer_users',
  CREDIT_NOTES_ID = 'credit_notes_id',
  COMMISSIONS = 'commissions',
  COMMISSIONS_ID = 'commissions_id',
  COMMISSION_CODES = 'commission_codes',
  COMMISSION_CODES_ID = 'commission_codes_id',
  AGENT_COMMISSION_CODES = 'agent_commission_codes',
  AGENT_COMMISSION_CODES_ID = 'agent_commission_codes_id',
  COVER_NOTES = 'cover_notes',
  COVER_NOTES_ID = 'cover_notes_id',
  CREDIT_DEBIT_NOTES = 'credit_debit_notes',
  CLAIMS = 'claims',
  CLAIMS_BULK_LIST = 'claims_bulk_list',
  CLAIMS_ID = 'claims_id',
  CLAIMS_UNIQUE_ID = 'claims_unique_id',
  CUSTOMERS = 'customers',

  // E
  EXTERNAL_USERS = 'external_users',
  ENDORSEMENTS = 'endorsements',
  ENDORSEMENTS_ID = 'endorsements_id',
  EXTERNAL_USERS_ID = 'external_users_id',

  // I
  INSURERS = 'insurers',
  INVOICES = 'invoices',
  INVOICES_ID = 'invoices_id',
  IDENTITIES_BMS_ID = 'identities_bms_id',
  INVOICE_TOKEN_BMS = 'invoice_token',

  // L
  LEADS_TRACKER = 'leads_tracker',
  LEADS_QUOTATION_ANALYSIS = 'leads_quotation_analysis',
  LEADS_ACCOUNT_HANDLER = 'leads_account_handler',

  // P
  PRODUCTS = 'products',
  POLICIES = 'policies',
  POLICIES_MEMBER_LIST = 'policies_member_list',
  PROPOSAL_ID = 'proposal_id',
}
